const WASTE_PLAN_LIMITS = {
    demo: {
        label: 'Demo',
        maxBranches: 1,
        maxEvidenceLists: 2,
        maxClients: 4,
        maxWarehouses: 1,
        maxContainers: 2,
        maxConsents: 1,
        maxOperationalLogs: 1,
        maxOperationalLogEntries: 14,
        price: 0,
    },
    start: {
        label: 'Start',
        maxBranches: 2,
        maxEvidenceLists: 9999,
        maxClients: 9999,
        maxWarehouses: 9999,
        maxContainers: 9999,
        maxConsents: 2,
        maxOperationalLogs: 0,
        maxOperationalLogEntries: 0,
        price: 14900,
    },
    business: {
        label: 'Business',
        maxBranches: 9,
        maxEvidenceLists: 9999,
        maxClients: 9999,
        maxWarehouses: 9999,
        maxContainers: 9999,
        maxConsents: 9999,
        maxOperationalLogs: 9999,
        maxOperationalLogEntries: 9999,
        price: 34900,
    },
};

const PPWR_PLAN_LIMITS = {
    demo: {
        label: 'Demo',
        maxPackagingUnits: 1,
        maxEuDeclarations: 1,
        maxTechnicalDocuments: 1,
        price: 0,
        tagline: 'Vyskúšajte PPWR modul zadarmo',
        suitableFor: [],
        features: ['1 Vyhlásenie o zhode', 'Exporty', '1 Technická dokumentácia', 'Identifikácia rolí', 'Automatické preklady (EN, DE, CS)', '30 dní zadarmo'],
    },
    S: {
        label: 'S',
        maxPackagingUnits: 4,
        price: 9000,
        tagline: 'Základná evidencia obalov pre menšie firmy',
        suitableFor: ['Malé firmy', 'Živnostníci', 'Nízky počet druhov obalov'],
        features: ['Evidencia obalov', 'Vyhlásenie o zhode', 'Exporty', 'Technická dokumentácia', 'Aktualizácie podľa legislatívy', 'Online podpora', 'Identifikácia rolí', 'Automatické preklady (EN, DE, CS)', 'Archivácia dokladov'],
    },
    M: {
        label: 'M',
        maxPackagingUnits: 18,
        price: 29000,
        tagline: 'Komplexná správa obalov pre rastúce firmy',
        suitableFor: ['Stredné firmy', 'Výrobcovia obalov', 'Viac obalových jednotiek'],
        features: ['Všetky funkcie balíka S'],
    },
    L: {
        label: 'L',
        maxPackagingUnits: 40,
        price: 59000,
        tagline: 'Najväčší balík pre firmy s vysokým objemom obalov',
        suitableFor: ['Veľké podniky a koncerny'],
        features: ['Všetky funkcie balíka M', 'Individuálne školenie'],
    },
};

const WASTE_PLAN_KEYS = Object.keys(WASTE_PLAN_LIMITS);
const PPWR_PLAN_KEYS = Object.keys(PPWR_PLAN_LIMITS);
const ALL_PLAN_KEYS = [...new Set([...WASTE_PLAN_KEYS, ...PPWR_PLAN_KEYS])];

// Backward compat — waste was the original "PLAN_LIMITS"
const PLAN_LIMITS = WASTE_PLAN_LIMITS;
const PLAN_KEYS = WASTE_PLAN_KEYS;
const PAID_PLAN_KEYS = WASTE_PLAN_KEYS.filter((k) => WASTE_PLAN_LIMITS[k].price > 0);
const FREE_PLAN = WASTE_PLAN_KEYS.find((k) => WASTE_PLAN_LIMITS[k].price === 0);

const VAT_RATE = 0.23;
const priceWithVat = (cents) => Math.round(cents * (1 + VAT_RATE));

module.exports = { WASTE_PLAN_LIMITS, PPWR_PLAN_LIMITS, WASTE_PLAN_KEYS, PPWR_PLAN_KEYS, ALL_PLAN_KEYS, PLAN_LIMITS, PLAN_KEYS, PAID_PLAN_KEYS, FREE_PLAN, VAT_RATE, priceWithVat };
